import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Typography, useTheme } from '@mui/material';

const ControlledNavLink = ({ disabled, to, children }) => {
    const { palette } = useTheme();
    // Keep ?lang=en etc. across breadcrumb clicks (BrowserRouter drops the query otherwise).
    const { search } = useLocation();

    if (disabled) {
        return <Typography variant="body1">{children}</Typography>;
    }

    return (
        <NavLink
            to={{ pathname: to, search }}
            style={({ isActive }) => ({
                color: palette.primary.main,
                fontWeight: isActive ? 600 : 400,
            })}
        >
            <Typography variant="body1" sx={{ fontWeight: 'inherit' }}>
                {children}
            </Typography>
        </NavLink>
    );
};

export { ControlledNavLink };
